import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { apiUrl } from './envirenment';
import { Router } from '@angular/router';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    handler: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = `${apiUrl}/${req.url}`;
    let update: {
      url?: string;
      setHeaders?: {
        [name: string]: string | string[];
      };
    } = {
      url,
    };
    update.setHeaders = {
      Account: '1',
    };
    const token = localStorage.getItem('JWT_Token');
    if (token) {
      update.setHeaders['Authorization'] = `Bearer ${token}`;
    }
    const clonedReq = req.clone(update);
    return handler
      .handle(clonedReq)
      .pipe(catchError((x) => this.handleAuthError(x, req.url)));
  }

  private handleAuthError(
    err: HttpErrorResponse,
    url?: string
  ): Observable<any> {
    if ((err.status === 401 || err.status === 403) && url != 'auth') {
      this.router.navigateByUrl(`/login`);
      return of(err.message);
    }
    return throwError(err);
  }
}
